import { CounterType } from '@gripp/shared-logic';
import { FC } from 'react';
import { CounterExecutionComponentProps } from './counterExecutionComponent';
import { GenericCounterExecutionComponent } from './genericCounterExecutionComponent';
import { SimpleCounterExecutionComponent } from './simpleCounterExecutionComponent';
import { TallyCounterExecutionComponent } from './tallyCounterExecutionComponent';

const CumulativeCounter = (props: CounterExecutionComponentProps) => (
  <GenericCounterExecutionComponent {...props} />
);
const SimpleCounter = (props: CounterExecutionComponentProps) => (
  <SimpleCounterExecutionComponent {...props} />
);
const TallyCounter = (props: CounterExecutionComponentProps) => (
  <TallyCounterExecutionComponent {...props} />
);

export type CounterTypeComponent = FC<CounterExecutionComponentProps>;
export const CounterTypeComponents: Record<CounterType, CounterTypeComponent> =
  {
    [CounterType.Cumulative]: CumulativeCounter,
    [CounterType.Simple]: SimpleCounter,
    [CounterType.Tally]: TallyCounter,
  };
